import { scheduleVideoStart } from './video-start-delay.js';

for (const wrapper of document.querySelectorAll('.video-wrapper')) {
	const video = wrapper.querySelector('video');
	const button = wrapper.querySelector('.video-play-button');
	const embed = wrapper.querySelector('.video-delayed-embed');
	const delay = wrapper.dataset.videoStartDelay;

	if (embed) {
		const startEmbed = () => {
			if (!embed.isConnected) return;
			const content = embed.content.cloneNode(true);
			const iframe = content.querySelector('iframe[src]');
			if (iframe) {
				const source = new URL(iframe.getAttribute('src'), document.baseURI);
				if (source.hostname === 'player.vimeo.com') {
					source.searchParams.set('autopause', '0');
					iframe.setAttribute('src', source.toString());
				}
			}
			embed.replaceWith(content);
			wrapper.querySelector('.video-preview')?.remove();
			wrapper.classList.remove('video-wrapper--waiting');
		};
		const cancelDelay = scheduleVideoStart(wrapper, delay, startEmbed);
		button?.addEventListener('click', () => {
			cancelDelay();
			startEmbed();
		});
		continue;
	}

	if (!video || !button) {
		continue;
	}

	const updatePlaybackState = () => {
		const isPlaying = !video.paused && !video.ended;
		button.style.display = isPlaying ? 'none' : 'block';

		if (isPlaying) {
			wrapper.classList.remove('video-wrapper--waiting');
			video.controls = true;
		}
	};

	const play = async () => {
		try {
			await video.play();
		} catch {
			updatePlaybackState();
		}
	};
	const cancelDelay = scheduleVideoStart(wrapper, delay, play);
	button.addEventListener('click', () => {
		cancelDelay();
		play();
	});
	video.addEventListener('play', cancelDelay);

	video.addEventListener('playing', updatePlaybackState);
	video.addEventListener('pause', updatePlaybackState);
	video.addEventListener('ended', updatePlaybackState);

	updatePlaybackState();
}
